import {Component} from '@angular/core';
import {Router} from '@angular/router';
import {ApiService} from '../../../services/api.service';
import {TranslateService} from '@ngx-translate/core';
import {AuthenticationService} from '../../../services/authentication.service';

@Component({
  selector: 'app-profile-password',
  templateUrl: './profile-password.component.html',
  styleUrls: ['./profile-password.component.scss']
})
export class ProfilePasswordComponent {
  oldPassword = '';
  newPassword = '';
  confirmPassword = '';
  errorMessage: string = null;

  constructor(private apiService: ApiService, private router: Router,
              private authService: AuthenticationService,
              private translate: TranslateService) {
  }

  submit() {
    this.sniff('CHANGE_PASSWORD', '');
    this.errorMessage = null;
    if (this.translate.currentLang !== 'en') {
      if (this.newPassword.length === 0) {
        this.errorMessage = 'โปรดกรอกรหัสผ่าน';
      } else {
        if (this.confirmPassword !== this.newPassword) {
          this.errorMessage = 'รหัสผ่านไม่ตรงกัน';
        } else {
          this.apiService.updatePassword({
            old_password: this.oldPassword,
            new_password: this.newPassword
          }).subscribe(
            () => this.router.navigate(['']),
            error => {
              this.checkErrorMsg(error);
            }
          );
        }
      }
    } else {
      if (this.newPassword.length === 0) {
        this.errorMessage = 'Please fill Password';
      } else if (this.confirmPassword !== this.newPassword) {
        this.errorMessage = 'Passwords do not match.';
      } else {
        this.apiService.updatePassword({
          old_password: this.oldPassword,
          new_password: this.newPassword
        }).subscribe(
          () => {
            localStorage.removeItem('require_to_change_password');
            if (this.authService.isAccountant() || this.authService.isOperation()) {
              this.router.navigate(['/search']);
            } else {
              this.router.navigate(['']);
            }
          },
          error => {
            this.checkErrorMsg(error);
          }
        );
      }
    }

  }

  checkErrorMsg(error) {
    this.errorMessage = this.apiService.getErrorMessage(error, ' ');
  }

  sniff(action, target) {
    const data = {
      action: action,
      address: 'CHANGE_PASS',
      target: target
    };
    this.apiService.sniff(data).subscribe(
      (res: any) => {
      },
    );
  }
}



// WEBPACK FOOTER //
// /opt/app/src/app/features/profile/profile-password/profile-password.component.ts